import React, { PureComponent } from 'react';
import { Translate } from 'react-redux-i18n';

import StringUtil from '../../app/utils/string';

class UserImportErrors extends PureComponent {
  render() {
    const { errors = [] } = this.props;

    if (!errors.length) return null;

    return (
      <div className="items-errors">
        <hr />

        <h5><Translate value="dragAndDropUserErrorTitle" /></h5>

        {errors.map(error => (
          <React.Fragment key={error.email}>
            <p>
              <Translate value="email" />
              {': '}
              <b>{error.email}</b>

              {' - '}
              <Translate value="line" />
              {' '}
              {error.line}
              {': '}

              {error.types.map((type, index) => (
                <React.Fragment>
                  <Translate value={`dragAndDropUserError${StringUtil.capitalizeFirstLetter(type)}`} />
                  {index !== error.types.length - 1 ? ', ' : ''}
                </React.Fragment>
              ))}
            </p>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default UserImportErrors;
